import FormattedMessage from 'I18n/components/FormattedMessage';
import { Big } from 'foundations-components/transitional/components/Big';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const InvoicesPopoverErrorState = () => /*#__PURE__*/_jsx(Flex, {
  flexDirection: "column",
  alignItems: "center",
  padding: "100",
  children: /*#__PURE__*/_jsx(Big, {
    textAlign: "center",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.invoices.fetchError"
    })
  })
});
export default InvoicesPopoverErrorState;